import React from 'react';
import { motion } from 'framer-motion';
import { Gift } from 'lucide-react';
export function BonusSection() {
  const bonuses = [{
    title: '📅 Planificador Visual "7 Días Sin Estrés"',
    value: '$8.000'
  }, {
    title: '🛒 Checklist "Compra Inteligente en 20 Minutos"',
    value: '$8.000'
  }, {
    title: '🚨 Comidas de Emergencia con lo que ya Tenés',
    value: '$9.000'
  }, {
    title: '👀 Recetas Invisibles para que los Chicos Coman Mejor',
    value: '$8.000'
  }, {
    title: '❄️ Freezer Inteligente y Porcionado Perfecto',
    value: '$9.000'
  }, {
    title: '🍽️ 50 Combinaciones Baratas que Siempre Funcionan',
    value: '$9.000'
  }];
  return <section className="py-20 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto relative" data-id="element-19">
      <div className="absolute inset-0 bg-gold-500/5 blur-[100px] rounded-full pointer-events-none" data-id="element-20"></div>

      <div className="text-center mb-16 relative z-10" data-id="element-21">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-22">
          <div className="inline-flex items-center justify-center p-4 bg-gold-500/10 rounded-full mb-6" data-id="element-23">
            <Gift className="w-10 h-10 text-gold-400" data-id="element-24" />
          </div>
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-4" data-id="element-25">
            🎁 6 BONOS — SIEMPRE INCLUIDOS
          </h2>
        </motion.div>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 relative z-10" data-id="element-26">
        {bonuses.map((bonus, index) => <motion.div key={index} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: index * 0.1
      }} className="bg-navy-800/80 border border-navy-600 p-6 rounded-2xl relative overflow-hidden flex flex-col" data-id="element-27">
            <div className="absolute top-0 right-0 bg-gold-500 text-navy-900 text-xs font-bold px-3 py-1 rounded-bl-lg z-10" data-id="element-28">
              BONO {index + 1}
            </div>

            <h4 className="text-xl font-bold text-white mb-6 pr-16 mt-2 flex-grow" data-id="element-29">
              {bonus.title}
            </h4>

            <div className="flex items-center justify-between mt-auto pt-4 border-t border-navy-700" data-id="element-30">
              <span className="text-gray-400 line-through text-sm" data-id="element-31">
                {bonus.value}
              </span>
              <span className="text-green-400 font-bold" data-id="element-32">GRATIS</span>
            </div>
          </motion.div>)}
      </div>

      <motion.div initial={{
      opacity: 0,
      scale: 0.95
    }} whileInView={{
      opacity: 1,
      scale: 1
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.6,
      delay: 0.4
    }} className="mt-16 text-center bg-navy-800/50 border border-gold-500/50 py-6 px-8 rounded-2xl max-w-2xl mx-auto relative z-10" data-id="element-33">
        <p className="text-xl md:text-2xl text-white" data-id="element-34">
          Valor total bonos:{' '}
          <span className="line-through text-gray-400" data-id="element-35">$51.000</span>{' '}
          <span className="text-gold-400 font-bold ml-2" data-id="element-36">
            → GRATIS con tu MegaPack
          </span>
        </p>
      </motion.div>
    </section>;
}